import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  protected readonly platformId = inject(PLATFORM_ID);

  protected trackingId: string;

  init(trackingId: string) {
    this.trackingId = trackingId;

    console.log('INIT GOOGLE ANALYTICS ', trackingId);

    if (isPlatformBrowser(this.platformId)) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
      script.async = true;

      script.onload = () => {
        (<any>window).dataLayer = (<any>window).dataLayer || [];
        this.gtag('js', new Date());
        this.pageView();
      };

      document.head.appendChild(script);
    }
  }

  gtag(...any) {
    if (isPlatformBrowser(this.platformId)) {
      (<any>window).dataLayer?.push(arguments);
    }
  }

  pageView(options?) {
    this.gtag('config', this.trackingId, options);
  }
}
